import { render, staticRenderFns } from "./InvoiceResearch.vue?vue&type=template&id=3d4a7bf6&scoped=true&"
import script from "./InvoiceResearch.vue?vue&type=script&lang=js&"
export * from "./InvoiceResearch.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceResearch.vue?vue&type=style&index=0&id=3d4a7bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a7bf6",
  null
  
)

export default component.exports